import { CircularProgress, Typography, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import MenuButton from './MenuButton';
import Filter from './Filter';
import { companies, dropDowns } from '../store/reducers';
import CFIDRegion from '../assets/CFID_Regions.jpg'
import AllMapAddress from "./AllMapAddress";
import { FaAnglesLeft, FaAnglesRight } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';
import { decryptAndRetrieveData } from './login/encript-decript';

function Dynamicroute() {
    const { route } = useSelector((state) => state.counter);
    const { titlename } = useSelector((state) => state.counter);
    const [filterPayload, setFilterPayload] = useState({});
    const [filterData, setFilterData] = useState(null);
    const [page, setpage] = useState(1);
    const [loading, setloading] = useState(false);
    const [company, setcompany] = useState();
    const [selectcompany, setselectcompany] = useState();
    const [index, setIndex] = useState(0);
    const [click, setclick] = useState(false);
    const [border, setBorder] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const detaildata = location.state?.route1;
    const title = location.state?.title
    
    // Check if user is logged in
    const user = decryptAndRetrieveData("isAuth", "123456789");
    const token = localStorage.getItem("accessToken");
    const isLoggedIn = user && token;

    const handleclose = () => {
        setclick(false);
    };
    useEffect(() => {

        dispatch(dropDowns()).then((res) => {
            setFilterData(res.payload);
        });
    }, [dispatch]);

    const filter = (filterData) => {
        setFilterPayload(filterData);
    };

    const handledata = (e, data, index) => {
        e.preventDefault();
        setselectcompany(data);
        setIndex(index);
        setclick(true);
        navigate('/company-detail', { state: { data } })
    };

    const handleprevious = () => {
        setpage(page - 1 !== 0 ? page - 1 : 1);
    };
    const handlenext = () => {
        if (company?.payload?.length == 9) {
            setpage(page + 1);
        }
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 991);

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        setloading(true);

        const payload = {
            page: page,
            page_size: 9,
            filters: {
                products_produced: title === 'Companies That Buy' ? [detaildata] : [] || [],
                products_purchased: title === 'Companies That Sell' ? [detaildata] : [] || [],
                services: title === 'Services' ? [detaildata] : [] || [],
                equipments: title === 'Equipment' ? [detaildata] : [] || [],
                region: filterPayload?.region,

            },
        };
        dispatch(companies(payload))
            .then((data) => {
                // Handle response: could be array directly or wrapped in payload
                const companyData = Array.isArray(data) ? { payload: data } : (data || { payload: [] });
                setcompany(companyData);
                setloading(false);
            })
            .catch((err) => {
                console.error('Error fetching companies:', err);
                setcompany({ payload: [] });
                setloading(false);
            });
    }, [filterPayload, page]);

    const highLighData = (address) => {
        setBorder(address);
    };
    const [userCurrentLocation, setUserCurrentLocation] = useState({
        x: -1,
        y: -1,
    });


    return (<>
        {loading && (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent background
                    zIndex: 1000, // Ensure loader stays on top
                }}
            >
                <CircularProgress style={{ color: "#4A5E00" }} />
            </div>
        )}
        <>
            <div className="container-fluid p-0 dy-h">
                <div class="row w-100 m-0 dy-h">
                    <div class={isMobile ? 'col-md-12' : 'col-md-10'}>
                        <div class="row">
                            <div className="col-lg-5 col-md-12 col-12">
                            <div><Typography className='d-flex justify-content-center' style={{ fontSize: '2em', margin: '0.5em', marginBottom: '1em', fontWeight: '600' }}></Typography></div>
                                <div className="content-box content-box-img">
                                    <img src={CFIDRegion} alt="" height={'518px'} width={'450px'} className="d-map img-fluid" />
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12 col-12">
                                <div className="content-box">
                                    <div className="row">
                                    <div><Typography className='d-flex justify-content-center' style={{ fontSize: '2em', margin: '0.5em', marginBottom: '1em', fontWeight: '600' }}>{detaildata}</Typography></div>

                                        <Filter data={filterData} filter={filter} setpage={setpage} setfilter={true} />

                                        {company?.payload && Array.isArray(company.payload) && company.payload.length > 0 ? (
                                            <>
                                                {company.payload.map((cdata, index) => {
                                                    // Check if company is unverified (show for all users)
                                                    // Show yellow color but no badge or tooltip
                                                    const isUnverified = (
                                                        cdata.admin_verified === null ||
                                                        cdata.admin_verified === undefined ||
                                                        cdata.is_verified_by_email === false ||
                                                        !cdata.is_verified_by_email
                                                    );
                                                    const companyColor = isUnverified ? "#FFD700" : "#A5BF45"; // Yellowish for unverified, green for verified
                                                    
                                                    return (
                                                    <div className="col-lg-4 col-md-4 col-12" style={{ marginTop: "1em" }} key={index}>
                                                        <div className="nested-box">
                                                            <div className="d-flex align-items-center flex-wrap">
                                                                <Tooltip title={isUnverified ? "Unclaimed" : ""}>
                                                                    <Typography
                                                                        style={{
                                                                            textDecoration: "underline",
                                                                            color: companyColor,
                                                                            cursor: "pointer",
                                                                            marginRight: "0.5em",
                                                                        }}
                                                                        onClick={(e) => handledata(e, cdata, index)}
                                                                    >
                                                                        <FaBuilding /> {cdata.name}
                                                                    </Typography>
                                                                </Tooltip>
                                                                <Typography>{cdata.city}, {cdata.state}</Typography>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    );
                                                })}

                                                {/* Pagination Controls */}
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        background: "white",
                                                        padding: "20px",
                                                        margin: "1.5em 0",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            cursor: page === 1 ? "not-allowed" : "pointer",
                                                            color: page === 1 ? "gray" : "black",
                                                            fontSize: "larger",
                                                        }}
                                                    >
                                                        <FaAnglesLeft style={{ marginRight: "1em" }} onClick={handleprevious} />
                                                    </span>

                                                    <span className="set-page-no">{page}</span>

                                                    <span
                                                        style={{
                                                            cursor: company?.payload?.length < 9 ? "not-allowed" : "pointer",
                                                            fontSize: "larger",
                                                            color: company?.payload?.length < 9 ? "gray" : "black",
                                                        }}
                                                    >
                                                        <FaAnglesRight style={{ marginLeft: "1em" }} onClick={handlenext} />
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="col-12 text-center" style={{ marginTop: "1em", color: "black" }}>
                                                No Companies Available.
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='dynamic-map' style={{ margin: '1em 1em 4em 1em', width: '98%' }}>
                            {/* {company?.payload?.length > 0 && ( */}
                                <AllMapAddress
                                    addresses={Array.isArray(company?.payload) ? company.payload : []}
                                    highLighData={highLighData}
                                    userCurrentLocation={userCurrentLocation}
                                    setUserCurrentLocation={setUserCurrentLocation}
                                />
                            {/* )} */}
                        </div>
                    </div>

                    {!isMobile &&
                        <div class="col-md-2" style={{ background: 'rgba(128 128 128 / 15%)' }}>

                            <div id='sidemenu' className="sidemenu">
                                <MenuButton />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    </>
    )
}

export default Dynamicroute
